


























import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import TextInput from '../../components/form/TextInput.vue';
import {defaultLoginFormData, LoginFormData} from "./types";
import {loginService} from "../../utils/shop/http-services";
import {ValidationObserver, ValidationProvider} from "vee-validate";

@Component({components: {TextInput, ValidationObserver, ValidationProvider}})
export default class GSLoginWidget extends Vue {
  @Prop() csrftoken!: string;
  @Prop() redirectlink!: string;
  @Prop() resetpasswordurl!: string;
  @Ref() validator!: typeof ValidationObserver;

  user: LoginFormData | null = null;
  error: string | null = null;

  created() {
    this.user = defaultLoginFormData;
  }

  async login() {
    const valid = await (this.validator as any).validate();
    if (!valid) return;
    loginService(this.csrftoken, this.mapToFormData())
    .then(response => {
      if (response.data.error) {
        this.error = '<p class="mb-3">' + response.data.error + '</p>';
      } else {
        this.error = null;
        window.location.href = this.redirectlink;
      }
    })
    .catch(ex => {
      console.error('Error', ex);
      this.error = "Es gab einen Fehler beim Login. Versuchen Sie es nochmals oder kontaktieren Sie uns direkt.";
    })
  }

  mapToFormData(): FormData {
    const formData = new FormData();

    formData.append('loginName', this.user?.email || '');
    formData.append('password', this.user?.password || '');

    return formData;
  }
}
